import React from 'react';

const ImportantLinks = () => {
  return (
    <div className="widget">
      <h4 className="widget-title">Important Links</h4>
      <div className="course-feature-list">
        <a href="#"><i className="far fa-book-open"></i> Overview </a>
        <a href="#"><i className="far fa-pencil"></i> Admit Card</a>
        <a href="#"><i className="far fa-clock"></i> Syllabus </a>
        <a href="#"><i className="far fa-globe"></i> Language </a>
        <a href="#"><i className="far fa-fill-drip"></i> Cut Off </a>
        <a href="#"><i className="far fa-location-dot"></i> Previous Year Papers </a>
        <a href="#"><i className="far fa-users"></i> Exam Dates </a>
        <a href="#"><i className="far fa-graduation-cap"></i> Results</a>
        <a href="#"><i className="far fa-check-circle"></i> Exam Analysis</a>
      </div>
    </div>
  );
};

export default ImportantLinks;
